import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Bell } from "lucide-react";
import api, { num } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function Row({ label, value }) {
  return <div className="flex justify-between py-2.5 border-b border-slate-100 last:border-0"><span className="text-slate-500 text-sm">{label}</span><span className="text-[#0A1128] font-medium text-sm">{value || "—"}</span></div>;
}

export default function WorkerProfile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [worker, setWorker] = useState(null);
  const [notifs, setNotifs] = useState([]);

  useEffect(() => {
    api.get("/me/worker").then((r) => setWorker(r.data.worker)).catch(() => {});
    api.get("/notifications").then((r) => setNotifs(r.data.items.slice(0, 8))).catch(() => {});
  }, []);

  return (
    <div className="space-y-5">
      <div className="bg-gradient-to-br from-[#0A1128] to-[#1E293B] rounded-3xl p-6 text-center text-white">
        <div className="h-20 w-20 rounded-full bg-[#1D4ED8] grid place-items-center text-3xl font-bold mx-auto">{(user?.name || "?")[0]}</div>
        <h1 className="font-head text-xl font-bold mt-3">{worker?.name || user?.name}</h1>
        <p className="text-slate-400 text-sm font-mono-metric">{worker?.worker_id}</p>
        <span className="inline-block mt-2 px-3 py-1 rounded-full bg-white/10 text-xs capitalize">{user?.role?.replace(/_/g, " ")}</span>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-5">
        <h2 className="font-head font-bold text-[#0A1128] mb-2">Profile</h2>
        <Row label="Email" value={worker?.email} />
        <Row label="Phone" value={worker?.phone} />
        <Row label="City" value={worker?.city_name} />
        <Row label="Region" value={worker?.region_name} />
        <Row label="Country" value={worker?.country_name} />
        <Row label="Team" value={worker?.team_name} />
        <Row label="Timezone" value={worker?.timezone} />
        <Row label="Skills" value={worker?.skills?.join(", ")} />
        <Row label="Joined" value={worker?.joining_date?.slice(0, 10)} />
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-5">
        <h2 className="font-head font-bold text-[#0A1128] mb-3 flex items-center gap-2"><Bell size={16} /> Notifications</h2>
        {notifs.length === 0 ? <p className="text-sm text-slate-400">No notifications yet.</p> : (
          <div className="space-y-2">
            {notifs.map((n) => (
              <div key={n.id} className="p-3 rounded-xl bg-slate-50" data-testid={`worker-notif-${n.id}`}>
                <div className="font-semibold text-[#0A1128] text-sm">{n.title}</div>
                <div className="text-slate-500 text-xs mt-0.5">{n.message}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <button onClick={() => { logout(); navigate("/login"); }} data-testid="worker-logout" className="w-full py-3.5 rounded-xl bg-white border border-slate-200 text-rose-500 font-semibold flex items-center justify-center gap-2">
        <LogOut size={18} /> Sign Out
      </button>
    </div>
  );
}
